if (!customElements.get('wls-accordion')) {
    class WLSAccordion extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                openClass: 'is-open',
            };
            
            this.toggle = this.toggle.bind(this);
        }

        connectedCallback() {
            if (this) {
                this.addEventListener('click', this.toggle);
            }
        }

        disconnectedCallback() {
            if (this) {
                this.removeEventListener('click', this.toggle);
            }
        }

        toggle() {
            this.classList.toggle(this.classes.openClass);
        }
    }

    customElements.define('wls-accordion', WLSAccordion);
}
